(function () {
  function initCookieCalculator() {
    const modal = document.querySelector('[data-cookie-calculator-modal]');

    if (!modal || modal.dataset.initialized === 'true') {
      return;
    }

    modal.dataset.initialized = 'true';

    const dialog = modal.querySelector('.cc-cookie-modal__dialog');
    const calculator = modal.querySelector('[data-cookie-calculator]');

    if (!calculator) {
      return;
    }

    const stepOrder = {
      calculator: 0,
      contact: 1,
      success: 2
    };

    const quantityNumberInput = calculator.querySelector('[data-field="quantity-number"]');
    const quantityRangeInput = calculator.querySelector('[data-field="quantity-range"]');
    const variantOptions = calculator.querySelector('[data-variant-options]');
    const nextButton = calculator.querySelector('[data-cookie-calculator-next]');
    const submitButton = calculator.querySelector('[data-cookie-calculator-submit]');
    const stepIndicators = Array.from(calculator.querySelectorAll('[data-step-indicator]'));
    const stepPanels = Array.from(calculator.querySelectorAll('[data-step-panel]'));
    const contactForm = calculator.querySelector('.cc-cookie-calculator__contact-form');
    const requestEndpoint = calculator.getAttribute('data-request-endpoint') || (contactForm ? contactForm.action : '');

    const contactNameInput = calculator.querySelector('#CookieCalculatorName');
    const companyInput = calculator.querySelector('#CookieCalculatorCompany');
    const emailInput = calculator.querySelector('#CookieCalculatorEmail');
    const phoneInput = calculator.querySelector('#CookieCalculatorPhone');
    const vatInput = calculator.querySelector('#CookieCalculatorVat');
    const streetInput = calculator.querySelector('#CookieCalculatorStreet');
    const zipInput = calculator.querySelector('#CookieCalculatorZip');
    const cityInput = calculator.querySelector('#CookieCalculatorCity');
    const noteInput = calculator.querySelector('#CookieCalculatorNote');
    const deliveryDateInput = calculator.querySelector('#CookieCalculatorDeliveryDate');

    const requestSelectionInput = calculator.querySelector('[data-field="request-selection"]');
    const requestQuantityInput = calculator.querySelector('[data-field="request-quantity"]');
    const requestQuantityRawInput = calculator.querySelector('[data-field="request-quantity-raw"]');
    const requestUnitPriceInput = calculator.querySelector('[data-field="request-unit-price"]');
    const requestUnitPriceRawInput = calculator.querySelector('[data-field="request-unit-price-raw"]');
    const requestTotalPriceInput = calculator.querySelector('[data-field="request-total-price"]');
    const requestPageInput = calculator.querySelector('[data-field="request-page"]');

    const errorMessage = calculator.querySelector('[data-cookie-calculator-errors]');
    const successMessage = calculator.querySelector('[data-cookie-calculator-success]');
    const successTextOutput = calculator.querySelector('[data-output="success-text"]');
    const successReferenceOutput = calculator.querySelector('[data-output="success-reference"]');

    const freeShippingBadge = calculator.querySelector('[data-free-shipping]');

    const selectionOutput = calculator.querySelector('[data-output="selection"]');
    const quantityValueOutput = calculator.querySelector('[data-output="quantity-value"]');
    const basePriceOutput = calculator.querySelector('[data-output="base-price"]');
    const unitPriceOutput = calculator.querySelector('[data-output="unit-price"]');
    const totalPriceOutput = calculator.querySelector('[data-output="total-price"]');
    const contactSelectionOutput = calculator.querySelector('[data-output="selection-contact"]');
    const contactQuantityOutput = calculator.querySelector('[data-output="quantity-contact"]');
    const contactUnitPriceOutput = calculator.querySelector('[data-output="unit-price-contact"]');
    const contactTotalPriceOutput = calculator.querySelector('[data-output="total-price-contact"]');
    const totalPriceInclOutput = calculator.querySelector('[data-output="total-price-incl"]');
    const contactTotalPriceInclOutput = calculator.querySelector('[data-output="total-price-incl-contact"]');
    const milestoneOutput = calculator.querySelector('[data-output="milestone"]');

    const calculatorConfig = {
      prices: {
        round: {
          label: 'Rond',
          sizes: {
            '4': 2.05,
            '5': 2.20,
            '6': 2.45,
            '7': 2.75
          }
        },
        square: {
          label: 'Vierkant',
          sizes: {
            '4': 2.05,
            '5': 2.20,
            '6': 2.45
          }
        }
      },
      discount: {
        startQty: 500,
        maxQty: 10000,
        maxPercent: 0.15
      },
      minQty: 30,
      vatRate: 0.09
    };

    const currencyFormatter = new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: 'EUR'
    });

    const numberFormatter = new Intl.NumberFormat('nl-NL');

    function addWorkingDays(startDate, days) {
      const d = new Date(startDate);
      let added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        const dow = d.getDay();
        if (dow !== 0 && dow !== 6) {
          added++;
        }
      }
      return d;
    }

    function toDateInputValue(d) {
      const year  = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day   = String(d.getDate()).padStart(2, '0');
      return year + '-' + month + '-' + day;
    }

    if (deliveryDateInput) {
      deliveryDateInput.min = toDateInputValue(addWorkingDays(new Date(), 10));
    }

    let lastTrigger = null;
    let currentSummary = null;
    let currentStep = 'calculator';
    let prevAbove500 = false;
    let lastFlyTime = 0;

    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function getMilestoneText(qty) {
      if (qty < 100)  return 'Een leuke traktatie 🎉';
      if (qty < 250)  return 'Perfect voor een feestje 🎂';
      if (qty < 500)  return 'Een flinke partij 🎊';
      if (qty < 1000) return 'Volumekorting actief, jij bespaart! 💰';
      if (qty < 2500) return 'Feest + gratis levering 🚀';
      if (qty < 5000) return 'Serieuze koekjeskrachten 💼';
      return 'Koekjeskoning status bereikt 👑';
    }

    function popElement(el) {
      if (!el || prefersReducedMotion()) return;
      el.classList.remove('cc-pop');
      void el.offsetWidth;
      el.classList.add('cc-pop');
    }

    function getThumbPosition(rangeInput) {
      const rect = rangeInput.getBoundingClientRect();
      const min = Number(rangeInput.min) || 0;
      const max = Number(rangeInput.max) || 100;
      const val = Number(rangeInput.value);
      const thumbWidth = 32;
      const trackWidth = rect.width - thumbWidth;
      const percent = Math.max(0, Math.min(1, (val - min) / (max - min)));
      return {
        x: rect.left + thumbWidth / 2 + trackWidth * percent,
        y: rect.top + rect.height / 2
      };
    }

    function spawnFlyingCookie(rangeInput) {
      if (prefersReducedMotion()) return;
      const now = Date.now();
      if (now - lastFlyTime < 150) return;
      lastFlyTime = now;
      const pos = getThumbPosition(rangeInput);
      const el = document.createElement('span');
      el.className = 'cc-cookie-fly';
      el.textContent = '🍪';
      el.style.left = (pos.x - 11) + 'px';
      el.style.top = (pos.y - 11) + 'px';
      document.body.appendChild(el);
      el.addEventListener('animationend', function () { el.remove(); }, { once: true });
    }

    function spawnConfetti(anchorEl) {
      if (prefersReducedMotion() || !anchorEl) return;
      const rect = anchorEl.getBoundingClientRect();
      const cx = rect.left + rect.width / 2;
      const cy = rect.top + rect.height / 2;
      const count = 8;
      for (let i = 0; i < count; i++) {
        const el = document.createElement('span');
        el.className = 'cc-cookie-confetti';
        el.textContent = '🍪';
        const angle = (i / count) * 2 * Math.PI;
        const dist = 50 + Math.random() * 40;
        el.style.left = cx + 'px';
        el.style.top = cy + 'px';
        el.style.setProperty('--cc-dx', Math.round(Math.cos(angle) * dist) + 'px');
        el.style.setProperty('--cc-dy', Math.round(Math.sin(angle) * dist) + 'px');
        el.style.setProperty('--cc-rot', Math.round(Math.random() * 360) + 'deg');
        el.style.animationDelay = (i * 35) + 'ms';
        document.body.appendChild(el);
        el.addEventListener('animationend', function () { el.remove(); }, { once: true });
      }
    }

    function spawnCookieRain() {
      if (prefersReducedMotion()) return;
      const count = 12;
      for (let i = 0; i < count; i++) {
        const el = document.createElement('span');
        el.className = 'cc-cookie-rain';
        el.textContent = '🍪';
        el.style.setProperty('--cc-x', (5 + Math.random() * 90) + 'vw');
        el.style.setProperty('--cc-duration', (1 + Math.random() * 1.4) + 's');
        el.style.setProperty('--cc-delay', (Math.random() * 0.7) + 's');
        el.style.setProperty('--cc-size', (16 + Math.random() * 14) + 'px');
        el.style.setProperty('--cc-rot', (Math.random() > 0.5 ? '' : '-') + Math.round(180 + Math.random() * 180) + 'deg');
        document.body.appendChild(el);
        el.addEventListener('animationend', function () { el.remove(); }, { once: true });
      }
    }

    function focusLater(element) {
      window.setTimeout(function () {
        if (element && typeof element.focus === 'function') {
          element.focus();
        }
      }, 40);
    }

    function setStep(step) {
      const isNewSuccess = step === 'success' && currentStep !== 'success';
      currentStep = step;
      calculator.setAttribute('data-current-step', step);

      stepPanels.forEach(function (panel) {
        const isActive = panel.getAttribute('data-step-panel') === step;
        panel.hidden = !isActive;
      });

      stepIndicators.forEach(function (indicator) {
        const indicatorStep = indicator.getAttribute('data-step-indicator');
        const isActive = indicatorStep === step;
        const isComplete = stepOrder[indicatorStep] < stepOrder[step];

        indicator.classList.toggle('is-active', isActive);
        indicator.classList.toggle('is-complete', isComplete);
      });

      if (dialog) {
        dialog.scrollTop = 0;
      }

      if (isNewSuccess) {
        spawnCookieRain();
      }
    }

    function openModal(trigger, step, focusTarget) {
      if (trigger) {
        lastTrigger = trigger;
      }

      clearError();
      restoreContactFromStorage();
      modal.hidden = false;
      document.documentElement.classList.add('cc-cookie-modal-open');
      document.body.classList.add('cc-cookie-modal-open');
      setStep(step || 'calculator');
      focusLater(focusTarget || quantityNumberInput);
    }

    function closeModal() {
      modal.hidden = true;
      document.documentElement.classList.remove('cc-cookie-modal-open');
      document.body.classList.remove('cc-cookie-modal-open');

      if (lastTrigger && typeof lastTrigger.focus === 'function') {
        lastTrigger.focus();
      }
    }

    function sanitizeQuantity(value, min, max) {
      const parsed = parseInt(value, 10);

      if (!Number.isFinite(parsed)) {
        return min;
      }

      if (parsed < min) {
        return min;
      }

      if (parsed > max) {
        return max;
      }

      return parsed;
    }

    function getDiscount(quantity) {
      const startQty = calculatorConfig.discount.startQty;
      const maxQty = calculatorConfig.discount.maxQty;
      const maxPercent = calculatorConfig.discount.maxPercent;

      if (quantity < startQty) {
        return 0;
      }

      if (quantity >= maxQty) {
        return maxPercent;
      }

      const progress = Math.log(quantity / startQty) / Math.log(maxQty / startQty);
      return Math.max(0, Math.min(progress, 1)) * maxPercent;
    }

    function getSizesForShape(shapeValue) {
      return Object.keys(calculatorConfig.prices[shapeValue].sizes).sort(function (a, b) {
        return Number(a) - Number(b);
      });
    }

    function renderVariantOptions(container, inputName, selectedValue) {
      const allVariants = [];

      Object.keys(calculatorConfig.prices).forEach(function (shapeValue) {
        getSizesForShape(shapeValue).forEach(function (sizeValue) {
          allVariants.push(shapeValue + '|' + sizeValue);
        });
      });

      const resolvedValue = allVariants.indexOf(selectedValue) !== -1 ? selectedValue : allVariants[0];

      container.innerHTML = Object.keys(calculatorConfig.prices)
        .map(function (shapeValue) {
          const previewShapeClass = shapeValue === 'round' ? 'cc-cookie-calculator__size-preview--round' : 'cc-cookie-calculator__size-preview--square';
          const shapeLabel = calculatorConfig.prices[shapeValue].label;
          const optionsHtml = getSizesForShape(shapeValue)
            .map(function (sizeValue) {
              const variantValue = shapeValue + '|' + sizeValue;
              const checkedAttribute = variantValue === resolvedValue ? ' checked' : '';

              return (
                '<label class="cc-cookie-calculator__choice">' +
                  '<input class="cc-cookie-calculator__choice-input" type="radio" name="' + inputName + '" value="' + variantValue + '" data-field="variant" data-shape="' + shapeValue + '" data-size="' + sizeValue + '"' + checkedAttribute + '>' +
                  '<span class="cc-cookie-calculator__choice-card">' +
                    '<span class="cc-cookie-calculator__size-preview ' + previewShapeClass + ' cc-cookie-calculator__size-preview--' + sizeValue + '">' + sizeValue + '</span>' +
                    '<span class="cc-cookie-calculator__choice-label">' + sizeValue + ' cm</span>' +
                  '</span>' +
                '</label>'
              );
            })
            .join('');

          return (
            '<div class="cc-cookie-calculator__variant-row">' +
              '<div class="cc-cookie-calculator__variant-heading">' + shapeLabel + '</div>' +
              '<div class="cc-cookie-calculator__variant-options">' + optionsHtml + '</div>' +
            '</div>'
          );
        })
        .join('');
    }

    function updateRangeProgress(rangeInput, quantity) {
      const min = Number(rangeInput.min) || calculatorConfig.minQty;
      const max = Number(rangeInput.max) || 10000;
      const progress = ((quantity - min) / (max - min)) * 100;
      rangeInput.style.setProperty('--cc-range-fill', progress + '%');
    }

    function getSelectedVariantInput() {
      return calculator.querySelector('[data-field="variant"]:checked');
    }

    function syncQuantity(quantity) {
      quantityNumberInput.value = quantity;
      quantityRangeInput.value = quantity;
      updateRangeProgress(quantityRangeInput, quantity);
    }

    function updateRequestFields(summary) {
      if (!summary) {
        return;
      }

      if (requestSelectionInput) {
        requestSelectionInput.value = summary.selection;
      }

      if (requestQuantityInput) {
        requestQuantityInput.value = summary.quantity;
      }

      if (requestQuantityRawInput) {
        requestQuantityRawInput.value = summary.quantityRaw;
      }

      if (requestUnitPriceInput) {
        requestUnitPriceInput.value = summary.unitPrice;
      }

      if (requestUnitPriceRawInput) {
        requestUnitPriceRawInput.value = summary.unitPriceRaw != null
          ? summary.unitPriceRaw.toFixed(4)
          : '';
      }

      if (requestTotalPriceInput) {
        requestTotalPriceInput.value = summary.totalPrice;
      }

      if (requestPageInput) {
        requestPageInput.value = window.location.href;
      }
    }

    function render(source) {
      const sourceValue = source === 'range' ? quantityRangeInput.value : quantityNumberInput.value;
      const quantity = sanitizeQuantity(sourceValue, calculatorConfig.minQty, 10000);
      const selectedVariantInput = getSelectedVariantInput();
      const shapeValue = selectedVariantInput ? selectedVariantInput.getAttribute('data-shape') : 'round';
      const sizeValue = selectedVariantInput ? selectedVariantInput.getAttribute('data-size') : '4';
      const shapeLabel = calculatorConfig.prices[shapeValue].label;
      const basePriceInclVat = calculatorConfig.prices[shapeValue].sizes[sizeValue];
      const discount = getDiscount(quantity);
      const unitPriceInclVat = basePriceInclVat * (1 - discount);
      const basePriceExVat = Math.round(basePriceInclVat / (1 + calculatorConfig.vatRate) * 100) / 100;
      const unitPriceExVat = Math.round(unitPriceInclVat / (1 + calculatorConfig.vatRate) * 100) / 100;
      const totalPriceInclVat = Math.round(unitPriceInclVat * quantity * 100) / 100;
      const totalPriceExVat = Math.round(totalPriceInclVat / (1 + calculatorConfig.vatRate) * 100) / 100;
      const formattedTotalPriceIncl = currencyFormatter.format(totalPriceInclVat);
      const formattedSelection = shapeLabel + ' ' + sizeValue + ' cm';
      const formattedQuantity = numberFormatter.format(quantity) + ' stuks';
      const formattedBasePrice = currencyFormatter.format(basePriceExVat);
      const formattedUnitPrice = currencyFormatter.format(unitPriceExVat);
      const formattedTotalPrice = currencyFormatter.format(totalPriceExVat);

      syncQuantity(quantity);
      calculator.classList.toggle('cc-cookie-calculator--discount-active', unitPriceExVat < basePriceExVat);

      const above500 = quantity >= calculatorConfig.discount.startQty;

      if (freeShippingBadge) {
        freeShippingBadge.hidden = quantity < 1000;
      }

      if (above500 && !prevAbove500) {
        spawnConfetti(totalPriceOutput);
      }

      prevAbove500 = above500;

      if (milestoneOutput) {
        milestoneOutput.textContent = getMilestoneText(quantity);
      }

      selectionOutput.textContent = formattedSelection;
      quantityValueOutput.textContent = formattedQuantity;
      basePriceOutput.textContent = formattedBasePrice;
      unitPriceOutput.textContent = formattedUnitPrice;
      totalPriceOutput.textContent = formattedTotalPrice;
      popElement(totalPriceOutput);

      if (totalPriceInclOutput) {
        totalPriceInclOutput.textContent = formattedTotalPriceIncl + ' incl. btw (9%)';
      }

      if (contactSelectionOutput) {
        contactSelectionOutput.textContent = formattedSelection;
      }

      if (contactQuantityOutput) {
        contactQuantityOutput.textContent = formattedQuantity;
      }

      if (contactUnitPriceOutput) {
        contactUnitPriceOutput.textContent = formattedUnitPrice + ' p/stuk';
      }

      if (contactTotalPriceOutput) {
        contactTotalPriceOutput.textContent = formattedTotalPrice;
      }

      if (contactTotalPriceInclOutput) {
        contactTotalPriceInclOutput.textContent = formattedTotalPriceIncl + ' incl. btw';
      }

      currentSummary = {
        selection: formattedSelection,
        quantity: formattedQuantity,
        quantityRaw: quantity,
        unitPrice: formattedUnitPrice,
        unitPriceRaw: unitPriceExVat,
        totalPrice: formattedTotalPrice
      };

      updateRequestFields(currentSummary);
    }

    const LS_KEY = 'cc_contact_form';
    const LS_FIELDS = ['company', 'kvk_number', 'name', 'phone', 'vat_number', 'street', 'postal_code', 'city', 'note'];

    function saveContactToStorage() {
      try {
        const data = {};
        LS_FIELDS.forEach(function (name) {
          const el = contactForm ? contactForm.elements[name] : null;
          if (el) {
            data[name] = el.value;
          }
        });
        localStorage.setItem(LS_KEY, JSON.stringify(data));
      } catch (e) {}
    }

    function restoreContactFromStorage() {
      try {
        const raw = localStorage.getItem(LS_KEY);
        if (!raw || !contactForm) {
          return;
        }
        const data = JSON.parse(raw);
        if (typeof data !== 'object' || data === null) {
          return;
        }
        LS_FIELDS.forEach(function (name) {
          if (typeof data[name] === 'string') {
            const el = contactForm.elements[name];
            if (el && el.value === '') {
              el.value = data[name];
            }
          }
        });
      } catch (e) {}
    }

    function clearContactStorage() {
      try {
        localStorage.removeItem(LS_KEY);
      } catch (e) {}
    }

    function escapeHtml(text) {
      const div = document.createElement('div');
      div.appendChild(document.createTextNode(String(text)));
      return div.innerHTML;
    }

    function clearError() {
      if (!errorMessage) {
        return;
      }

      errorMessage.innerHTML = '';
      errorMessage.hidden = true;
    }

    function showError(message, errors) {
      if (!errorMessage) {
        return;
      }

      const safeMessage = message || 'Er ging iets mis bij het versturen van de offerteaanvraag.';
      let html = '<p>' + escapeHtml(safeMessage) + '</p>';

      if (Array.isArray(errors) && errors.length) {
        html += '<ul class="errors">' + errors.map(function (item) {
          return '<li>' + escapeHtml(item) + '</li>';
        }).join('') + '</ul>';
      }

      errorMessage.innerHTML = html;
      errorMessage.hidden = false;
      setStep('contact');
      focusLater(errorMessage);
    }

    function setSubmitting(isSubmitting) {
      if (!submitButton) {
        return;
      }

      submitButton.disabled = isSubmitting;
      if (isSubmitting) {
        submitButton.innerHTML = '<span class="cc-cookie-calculator__submit-icon cc-cookie-calculator__submit-icon--spin" aria-hidden="true">🍪</span> Bezig met versturen\u2026';
      } else {
        submitButton.textContent = 'Verstuur offerteaanvraag';
      }
    }

    function resetContactForm() {
      if (!contactForm) {
        return;
      }

      contactForm.reset();
      updateRequestFields(currentSummary);
      clearError();
    }

    function buildPayload() {
      updateRequestFields(currentSummary);

      const formData = new FormData(contactForm);
      const payload = {};

      formData.forEach(function (value, key) {
        payload[key] = typeof value === 'string' ? value.trim() : value;
      });

      return payload;
    }

    async function submitRequest(event) {
      event.preventDefault();
      clearError();

      if (!contactForm || !contactForm.reportValidity()) {
        return;
      }

      if (!requestEndpoint) {
        showError('Het aanvraagendpoint ontbreekt. Controleer de calculator-instellingen.');
        return;
      }

      setSubmitting(true);

      try {
        const payload = buildPayload();
        const response = await fetch(requestEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(payload)
        });

        const responseText = await response.text();
        let result = {};

        if (responseText) {
          try {
            result = JSON.parse(responseText);
          } catch (parseError) {
            throw new Error('De server gaf geen geldige JSON terug.');
          }
        }

        if (!response.ok || !result.ok) {
          showError(result.message || 'De offerteaanvraag kon niet worden verstuurd.', Array.isArray(result.errors) ? result.errors : []);
          return;
        }

        if (successTextOutput) {
          const submittedName = contactNameInput ? contactNameInput.value.trim() : '';
          const selectedVariant = getSelectedVariantInput();
          const shape = selectedVariant ? selectedVariant.getAttribute('data-shape') : 'round';
          const shapeWord = shape === 'square' ? 'vierkante' : 'ronde';
          const qty = currentSummary ? numberFormatter.format(currentSummary.quantityRaw) : '';

          if (submittedName && qty) {
            successTextOutput.textContent = 'Bedankt voor je offerteaanvraag ' + submittedName + ' voor ' + qty + ' ' + shapeWord + ' koekjes.';
          } else {
            successTextOutput.textContent = 'We nemen snel contact met je op.';
          }
        }

        if (successReferenceOutput) {
          if (result.request_id) {
            successReferenceOutput.hidden = false;
            successReferenceOutput.textContent = 'Referentie: ' + result.request_id;
          } else {
            successReferenceOutput.hidden = true;
            successReferenceOutput.textContent = '';
          }
        }

        if (typeof gtag === 'function' && currentSummary) {
          gtag('event', 'generate_lead', {
            currency:      'EUR',
            value:         currentSummary.quantityRaw
                             ? Math.round(parseFloat(
                                 currentSummary.totalPrice.replace(/[^0-9,]/g, '').replace(',', '.')
                               ) * 100) / 100
                             : 0,
            cookie_type:   currentSummary.selection,
            cookie_qty:    currentSummary.quantityRaw,
          });
        }

        clearContactStorage();
        resetContactForm();
        setStep('success');
        focusLater(successMessage);
      } catch (error) {
        showError(error instanceof Error ? error.message : 'Er ging iets mis bij het versturen van de offerteaanvraag.');
      } finally {
        setSubmitting(false);
      }
    }

    renderVariantOptions(variantOptions, 'cc-cookie-variant', 'round|4');
    render();
    setStep(currentStep);

    if (window.location.hash === '#offerte') {
      openModal(null, 'calculator', quantityNumberInput);
    }

    window.addEventListener('hashchange', function () {
      if (window.location.hash === '#offerte') {
        openModal(null, 'calculator', quantityNumberInput);
      }
    });

    document.addEventListener('click', function (event) {
      const openTrigger = event.target.closest('[data-cookie-calculator-open]');

      if (openTrigger) {
        event.preventDefault();
        openModal(openTrigger, 'calculator', quantityNumberInput);
        return;
      }

      const nextTrigger = event.target.closest('[data-cookie-calculator-next]');

      if (nextTrigger && modal.contains(nextTrigger)) {
        event.preventDefault();
        setStep('contact');
        saveContactToStorage();
        focusLater(contactNameInput);
        return;
      }

      const backTrigger = event.target.closest('[data-cookie-calculator-back]');

      if (backTrigger && modal.contains(backTrigger)) {
        event.preventDefault();
        setStep('calculator');
        focusLater(quantityNumberInput);
        return;
      }

      const closeTrigger = event.target.closest('[data-cookie-calculator-close]');

      if (closeTrigger && modal.contains(closeTrigger)) {
        closeModal();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) {
        closeModal();
      }
    });

    calculator.addEventListener('change', function (event) {
      if (event.target.matches('[data-field="variant"]')) {
        render();
      }
    });

    calculator.addEventListener('input', function (event) {
      if (event.target.matches('[data-field="quantity-range"]')) {
        spawnFlyingCookie(event.target);
        render('range');
        return;
      }

      if (event.target.matches('[data-field="quantity-number"]')) {
        const raw = parseInt(event.target.value, 10);
        if (Number.isFinite(raw) && raw >= calculatorConfig.minQty) {
          render('number');
        }
        return;
      }

      if (contactForm && event.target.closest('.cc-cookie-calculator__contact-form')) {
        updateRequestFields(currentSummary);
        clearError();
      }
    });

    calculator.addEventListener(
      'blur',
      function (event) {
        if (event.target.matches('[data-field="quantity-number"]')) {
          render('number');
        }
      },
      true
    );

    if (contactForm) {
      contactForm.addEventListener('submit', submitRequest);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCookieCalculator);
  } else {
    initCookieCalculator();
  }
})();